import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ApiError } from '../../action/apiError';
import { Notification, NotificationParams } from '../../types/resources/Notification';

export const createPushNotifications = async (
  data: NotificationParams
): Promise<{ notification: Notification }> => {
  const response = await partnerAdminFetch('/partner_admins/notifications', {
    method: 'POST',
    data: { notification: data },
  });

  if (!response.ok) {
    const errorDetails = await response.json();
    throw new ApiError(
      `HTTP ${response.status} ${response.statusText}`,
      errorDetails.errors || [errorDetails.message]
    );
  }

  return response.json();
};
